// import React, { useState } from 'react';
import { CardContent, Modal } from "@mui/material";
import { Box } from "@mui/system";
// import UploadImage from "";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  height: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 0,
  borderRadius: "1%",
};

const ImageModal = ({ img, openModal, setOpenModal }) => {
  const imagePath = process.env.REACT_APP_IMAGE_URL;
  return (
    <>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ overflow: "auto" }}
      >
        <Box sx={{ ...style, padding: "10px" }}>
          <CardContent>
            <img
              style={{ ...style, width: "100%", height: "100%" }}
              src={imagePath + img}
              alt={imagePath + img}
            />
          </CardContent>
        </Box>
      </Modal>
    </>
  );
};

export default ImageModal;
